// extracted by mini-css-extract-plugin
export default {"card":"Offer_card__4Rd7l","no-offer":"Offer_no-offer__CFu-T","footer":"Offer_footer__yyZQT"};